import { render, staticRenderFns } from "./shopping-list-modal.vue?vue&type=template&id=60145c41&scoped=true&"
import script from "./shopping-list-modal.vue?vue&type=script&lang=js&"
export * from "./shopping-list-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60145c41",
  null
  
)

export default component.exports